// import { useState, useEffect } from "react";
// import DashboardWidget from "../../components/widget/DashboardWidget";
// import SchoolIcon from '@mui/icons-material/School';
// import AccessTimeIcon from '@mui/icons-material/AccessTime';
// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// import BarChart from "../../components/chart/BarChart";
// // import "./dashboardCommon.scss";

// const CenterDashboard = () => {
//     // State for date/time
//     const [currentTime, setCurrentTime] = useState(new Date());

//     // State for class data
//     const [classData, setClassData] = useState([
//         { id: 'IX', name: 'Class IX', totalStudents: 25, presentToday: 20 },
//         { id: 'X', name: 'Class X', totalStudents: 25, presentToday: 23 },
//         { id: 'XI', name: 'Class XI', totalStudents: 25, presentToday: 25 },
//         { id: 'XII', name: 'Class XII', totalStudents: 25, presentToday: 24 }
//     ]);

//     // State for attendance data
//     const [attendanceData, setAttendanceData] = useState({
//         overall: [85, 90, 88, 92, 87, 89, 91],
//         classWise: {
//             IX: [80, 85, 82, 90, 84, 86, 88],
//             X: [90, 92, 89, 95, 91, 93, 94],
//             XI: [82, 85, 80, 87, 83, 84, 86],
//             XII: [88, 90, 87, 92, 89, 90, 91]
//         }
//     });

//     // State for graph filter
//     const [graphFilter, setGraphFilter] = useState('overall');

//     // Update time every second
//     useEffect(() => {
//         const timer = setInterval(() => {
//             setCurrentTime(new Date());
//         }, 1000);

//         return () => clearInterval(timer);
//     }, []);

//     // Generate last 7 working days (excluding Sundays)
//     const getLast7WorkingDays = () => {
//         const days = [];
//         const today = new Date();
//         let count = 0;

//         while (days.length < 7) {
//             const date = new Date();
//             date.setDate(today.getDate() - count);
//             count++;

//             // Skip Sunday (day 0)
//             if (date.getDay() !== 0) {
//                 days.push(date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }));
//             }
//         }

//         return days.reverse();
//     };

//     // Prepare chart data
//     const getChartData = () => {
//         const labels = getLast7WorkingDays();

//         return {
//             labels,
//             datasets: [
//                 {
//                     label: graphFilter === 'overall' ? 'Overall Attendance' : `Class ${graphFilter} Attendance`,
//                     data: graphFilter === 'overall'
//                         ? attendanceData.overall
//                         : attendanceData.classWise[graphFilter],
//                     backgroundColor: 'rgba(53, 162, 235, 0.5)',
//                     borderColor: 'rgb(53, 162, 235)',
//                     borderWidth: 1,
//                 }
//             ]
//         };
//     };

//     // Chart options
//     const chartOptions = {
//         responsive: true,
//         plugins: {
//             legend: {
//                 position: 'top',
//             },
//             title: {
//                 display: true,
//                 text: 'Attendance Trend (Last 7 Working Days)',
//             },
//         },
//         scales: {
//             y: {
//                 beginAtZero: true,
//                 max: 100,
//                 ticks: {
//                     callback: (value) => `${value}%`
//                 }
//             }
//         }
//     };

//     // Format date and time
//     const formattedDate = currentTime.toLocaleDateString('en-US', {
//         year: 'numeric',
//         month: 'long',
//         day: 'numeric'
//     });

//     const formattedDay = currentTime.toLocaleDateString('en-US', { weekday: 'long' });
//     const formattedTime = currentTime.toLocaleTimeString('en-US', {
//         hour: '2-digit',
//         minute: '2-digit',
//         second: '2-digit'
//     });

//     return (
//         <div className="dashboard center-dashboard">
//             <h2 className="dashboard-title">Today's Attendance</h2>

//             {/* Class Cards Section */}
//             <div className="widgets class-cards">
//                 {classData.map((classInfo) => (
//                     <DashboardWidget
//                         key={classInfo.id}
//                         title={classInfo.name}
//                         value={classInfo.totalStudents}
//                         secondary={`${classInfo.presentToday} / ${classInfo.totalStudents}`}
//                         icon={<SchoolIcon className="icon class-icon" />}
//                     />
//                 ))}
//             </div>

//             {/* Date & Time Section */}
//             <div className="datetime-section">
//                 <div className="datetime-card date-card">
//                     <CalendarTodayIcon className="datetime-icon" />
//                     <div className="datetime-content">
//                         <div className="date">{formattedDate}</div>
//                         <div className="day">{formattedDay}</div>
//                     </div>
//                 </div>

//                 <div className="datetime-card time-card">
//                     <AccessTimeIcon className="datetime-icon" />
//                     <div className="time">{formattedTime}</div>
//                 </div>
//             </div>

//             {/* Attendance Graph Section */}
//             <div className="attendance-graph">
//                 <div className="graph-header">
//                     <h2>Attendance Overview</h2>
//                     <div className="filter-control">
//                         <label>Filter by:</label>
//                         <select
//                             value={graphFilter}
//                             onChange={(e) => setGraphFilter(e.target.value)}
//                         >
//                             <option value="overall">Overall</option>
//                             <option value="IX">Class IX</option>
//                             <option value="X">Class X</option>
//                             <option value="XI">Class XI</option>
//                             <option value="XII">Class XII</option>
//                         </select>
//                     </div>
//                 </div>

//                 <div className="chart-container">
//                     <BarChart
//                         data={getChartData().datasets[0].data}
//                         labels={getChartData().labels}
//                         title="Attendance Trend (Last 7 Working Days)"
//                     />
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default CenterDashboard;



import { useState, useEffect } from "react";
import DashboardWidget from "../../components/widget/DashboardWidget";
import NotificationWidget from "../../components/widget/NotificationWidget";
import SchoolIcon from '@mui/icons-material/School';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import BarChart from "../../components/chart/BarChart";
import { serverUrl } from "../../temp";

const CenterDashboard = () => {
    const centerId = localStorage.getItem("center_id") || 1; // Get from localStorage
    const userId = JSON.parse(localStorage.getItem("admindata"))?.id || localStorage.getItem("admin_id");

    // Live time/date
    const [currentTime, setCurrentTime] = useState(new Date());

    // Data states
    const [classData, setClassData] = useState([]);
    const [attendanceData, setAttendanceData] = useState({
        overall: [],
        classWise: {}
    });

    const [graphFilter, setGraphFilter] = useState("overall");
    const [loading, setLoading] = useState(true);

    // Auto-update time
    useEffect(() => {
        const timer = setInterval(() => setCurrentTime(new Date()), 1000);
        return () => clearInterval(timer);
    }, []);

    // Fetch today’s attendance & trends on load
    useEffect(() => {
        fetchTodayAttendance();
    }, []);

    // Refetch trend when filter changes (for per-class trend)
    useEffect(() => {
        fetchAttendanceTrend();
    }, [graphFilter]);

    const fetchTodayAttendance = async () => {
        try {
            const res = await fetch(`${serverUrl}/result_dashboard/today_attendance?center_id=${centerId}`);
            const json = await res.json();

            if (json.code === "200") {
                const formatted = json.data.map(c => ({
                    id: c.class_id,
                    name: `Class ${c.class_name}`,
                    totalStudents: c.class_desc.total_students,
                    presentToday: Number(c.class_desc.present_students),
                    percentage: parseFloat(c.class_desc.attendance_percentage)
                }));

                setClassData(formatted);

                // Fetch overall trend right after we know class IDs
                fetchAttendanceTrend(formatted);
            }
        } catch (err) {
            console.error("Error fetching today's attendance:", err);
        }
    };

    const fetchAttendanceTrend = async (classList = classData) => {
        try {
            let trendData = {};

            if (graphFilter === "overall") {
                // Fetch all classes trends and average them
                let allTrends = [];

                for (const c of classList) {
                    const res = await fetch(`${serverUrl}/result_dashboard/attendance_trend?center_id=${centerId}&class_id=${c.id}`);
                    const json = await res.json();
                    if (json.code === "200") {
                        allTrends.push(json.data.map(d => d.info.attendance));
                        trendData.classWise = {
                            ...trendData.classWise,
                            [c.name.split(" ")[1]]: json.data.map(d => d.info.attendance)
                        };
                    }
                }

                if (allTrends.length > 0) {
                    // Calculate daily average across classes
                    const days = allTrends[0].length;
                    const avg = Array.from({ length: days }, (_, i) => {
                        const sum = allTrends.reduce((acc, arr) => acc + (arr[i] || 0), 0);
                        return parseFloat((sum / allTrends.length).toFixed(2));
                    });
                    trendData.overall = avg;
                }
            } else {
                // Only fetch selected class trend
                const classObj = classList.find(c => c.name.split(" ")[1] === graphFilter);
                if (classObj) {
                    const res = await fetch(`${serverUrl}/result_dashboard/attendance_trend?center_id=${centerId}&class_id=${classObj.id}`);
                    const json = await res.json();
                    if (json.code === "200") {
                        trendData.overall = json.data.map(d => d.info.attendance);
                    }
                }
            }

            setAttendanceData(prev => ({
                ...prev,
                ...trendData
            }));
            setLoading(false);
        } catch (err) {
            console.error("Error fetching attendance trend:", err);
        }
    };

    // Generate last 7 working days labels from backend trend data
    const getLabels = () => {
        if (graphFilter === "overall") {
            return classData.length
                ? getLast7WorkingDays()
                : [];
        } else {
            return getLast7WorkingDays();
        }
    };

    const getLast7WorkingDays = () => {
        const days = [];
        const today = new Date();
        let count = 0;
        while (days.length < 7) {
            const date = new Date();
            date.setDate(today.getDate() - count);
            count++;
            if (date.getDay() !== 0) {
                days.push(date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }));
            }
        }
        return days.reverse();
    };

    const getChartData = () => {
        const labels = getLabels();
        const data =
            graphFilter === "overall"
                ? attendanceData.overall
                : attendanceData.classWise[graphFilter] || [];

        return {
            labels,
            datasets: [
                {
                    label: graphFilter === 'overall' ? 'Overall Attendance' : `Class ${graphFilter} Attendance`,
                    data,
                    backgroundColor: 'rgba(53, 162, 235, 0.5)',
                    borderColor: 'rgb(53, 162, 235)',
                    borderWidth: 1,
                }
            ]
        };
    };

    const formattedDate = currentTime.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
    const formattedDay = currentTime.toLocaleDateString('en-US', { weekday: 'long' });
    const formattedTime = currentTime.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });

    return (
        <div className="dashboard center-dashboard">
            <h2 className="dashboard-title">Today's Attendance</h2>

            <div className="widgets class-cards">
                {loading ? (
                    <>
                        <DashboardWidget.Skeleton />
                        <DashboardWidget.Skeleton />
                        <DashboardWidget.Skeleton />
                        <DashboardWidget.Skeleton />
                    </>
                ) : (
                    classData.map(c => (
                        <DashboardWidget
                            key={c.id}
                            title={c.name}
                            value={`${c.percentage}%`}
                            secondary={`${c.presentToday} / ${c.totalStudents}`}
                            icon={<SchoolIcon className="icon class-icon" />}
                        />
                    ))
                )}
            </div>

            {/* Notification Widget
            <div className="notification-widget-container">
                <NotificationWidget userId={userId} />
            </div> */}

            <div className="datetime-section">
                <div className="datetime-card date-card">
                    <CalendarTodayIcon className="datetime-icon" />
                    <div className="datetime-content">
                        <div className="date">{formattedDate}</div>
                        <div className="day">{formattedDay}</div>
                    </div>
                </div>

                <div className="datetime-card time-card">
                    <AccessTimeIcon className="datetime-icon" />
                    <div className="time">{formattedTime}</div>
                </div>
            </div>

            {/* <div className="attendance-graph">
                <div className="graph-header">
                    <h2>Attendance Overview</h2>
                    <div className="filter-control">
                        <label>Filter by:</label>
                        <select value={graphFilter} onChange={(e) => setGraphFilter(e.target.value)}>
                            <option value="overall">Overall</option>
                            {classData.map(c => (
                                <option key={c.id} value={c.name.split(" ")[1]}>{c.name}</option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="chart-container">
                    <BarChart
                        data={getChartData().datasets[0].data}
                        labels={getChartData().labels}
                        title="Attendance Trend (Last 7 Working Days)"
                    />
                </div>
            </div> */}
            <div className="attendance-graph">
                <div className="graph-header">
                    <h1 className="graph-card-title">Attendance Overview</h1>
                    <div className="filter-control">
                        <label>Filter by:</label>
                        <select
                            value={graphFilter}
                            onChange={(e) => setGraphFilter(e.target.value)}
                            className="filter-select"
                        >
                            <option value="overall">Overall</option>
                            {classData.map(c => (
                                <option key={c.id} value={c.name.split(" ")[1]}>{c.name}</option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="chart-container h-96"> {/* Or any height you want */}
                    {!loading && (
                        <BarChart
                            data={getChartData().datasets[0].data}
                            labels={getChartData().labels}
                            title="Attendance Trend (Last 7 Working Days)"
                        />
                    )}
                </div>

            </div>
        </div>
    );
};

export default CenterDashboard;
